import { Injectable } from '@angular/core';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';

@Injectable({
  providedIn: 'root'
})
export class TableViewService {
  properties: any;
  //sorting the table
   selectedMetric: any = '';
  constructor(private commonchartmodules: CommonChartmoduleService) { }
  defaultBackgroundolor: any = 'white';
  defaultTextColor: any = 'black';
  darkThemeBackgroundColor: any = 'black';
  darkThemeTextColor: any = 'white';
  upwardTriangle = '&#9650';
  downwardTriangle = '\u25BC';
  highSignificance = 'green';
  lowSignificance = 'red';
  defaultThemeTextColor = 'black';
  changeValueFontSize = "70%";
  sampleSizeConstant = 9000;
  lowSampleText = "LS";
  borderThickness = "1px";
  color: string[]=this.commonchartmodules.color1;
  rowcustomizationService() {
    let custom: any = [
      { customization: 'Number of columns', func: 'commonfunc', inputType: 'number', value: 'colNumber' },

      { customization: 'Number of columns to merge', func: 'commonfunc', inputType: 'number', value: 2 },
      { customization: 'Alternate Row Color', func: 'commonfunc', inputType: 'checkbox', value: 'alternate Row' },
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox', value: 'Dark' },

      {
        customization: 'Border', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: '5px solid black', label: '5px solid black' },
          { value: '5px solid grey', label: '5px solid grey' },

          { value: '5px solid blue', label: '5px solid blue' },
          { value: 0, label: 'None' }


        ],

      },
      {
        customization: 'Border Style', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'dash', label: 'Dashed' },
          { value: 'dotted', label: 'Dotted' },

          { value: 'solid', label: 'Solid' },
          { value: 0, label: 'None' }


        ],
      },
      {
        customization: 'Text Color', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },
          { value: 'white', label: 'White' },
        ]
      },
      {
        customization: 'Cell Color', func: 'commonfunc', inputType: 'dropdwon', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },
          { value: 'white', label: 'White' },
        ]
      },
      {
        customization: 'Header Color', func: 'commonfunc', inputType: 'dropdwon', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },

        ]
      },
      //{
      //  customization: 'Cell Border', func: 'commonfunc', inputType: 'dropdwon', options: [
      //    { value: 'red', label: 'Red' },
      //    { value: 'green', label: 'Green' },
      //    { value: 'blue', label: 'Blue' },
      //    { value: 'black', label: 'Black' },

      //    { value: 'none', label: 'None' },
      //    { value: 'default', label: 'Default' }
      //  ]
      //},
      //{
      //  customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'dropdown', options: [
      //    { value: 'number', label: 'Number' },
      //    { value: 'percentage', label: 'Percentage' },
      //  ]
      //},


    ]
    return custom;
  }

  commonFuncrow(customization: any, event: any, property: any, tableElement: any, headerElement: any) {
    this.properties = property;

    const cells = tableElement.nativeElement.getElementsByTagName('td');
    const rows = tableElement.nativeElement.getElementsByTagName('tr');
    const cols = tableElement.nativeElement.getElementsByTagName('th');
    switch (customization) {
      case 'Border':
        this.properties.border = event.target.value;
        if (this.properties.border != 0) {

          tableElement.nativeElement.style.border = this.properties.border;
        } else {

          tableElement.nativeElement.style.border = 'none';
        }
        break;
      case 'Border Style':
        this.properties.border = event.target.value;
        if (this.properties.border != 0) {

          tableElement.nativeElement.style.border = this.properties.border;
        } else {

          tableElement.nativeElement.style.border = 'none';
        }
        break;
      case 'Text Color':
        this.properties.dataLabelColor = event.target.value;
        if (this.properties.dataLabelColor != "default") {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.color = this.properties.dataLabelColor;
          }

        } else {
          tableElement.nativeElement.style.color = 'black';
        }
        break;
      case 'Cell Color':
        this.properties.cellColor = event.target.value;

        if (this.properties.cellColor != "default") {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = this.properties.cellColor;
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = 'white';
          }
        }
        break;
      case 'Header Color':
        this.properties.headerColor = event.target.value;
        const rows2 = tableElement.nativeElement.getElementsByTagName('th');

        for (let i = 0; i < rows2.length; i++) {
          rows2[i].style.backgroundColor = this.properties.headerColor;
          rows2[i].style.color = 'white';

        }
        break;
      case 'Cell Border':
        this.properties.cellBorder = event.target.value;
        if (this.properties.cellBorder == 'none') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = 0;
          }
        }
        if (this.properties.cellBorder == 'default') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '1px solid #ddd';
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '5px solid ' + this.properties.cellBorder;
          }
        }

        break;
      case 'Alternate Row Color':
        this.properties.alternateColor = event.target.checked;
        const tbody = tableElement.nativeElement.querySelector('tbody'); // Get tbody element
        const evenRows = tbody.querySelectorAll('.even-row'); // Get even rows
        const oddRows = tbody.querySelectorAll('.odd-row'); // Get odd rows

        if (this.properties.alternateColor) {
          // Apply gray to even rows and white to odd rows
          oddRows.forEach((row: HTMLTableRowElement) => row.style.backgroundColor = '#f2f2f2');
          evenRows.forEach((row: HTMLTableRowElement) => row.style.backgroundColor = '#ffffff');
        } else {
          // Reset background color for all rows
          const allRows = tbody.querySelectorAll('.table-content');
          allRows.forEach((row: HTMLTableRowElement) => row.style.backgroundColor = '');
        }
        break;
      // Change the alternating bar color logic
      // case 'Alternate Row Color':
      //   this.properties.alternateColor = event.target.checked;
      //   const tbody = tableElement.nativeElement.querySelector('tbody'); // Get tbody element
      //   const rows = tbody.getElementsByTagName('tr'); // Get rows within tbody

      //   // Define alternate colors
      //   const oddColor = '#f2f2f2';
      //   const evenColor = '#ffffff';

      //   // Toggle row colors based on the checkbox value
      //   for (let i = 0; i < rows.length; i++) {
      //     if (this.properties.alternateColor) {
      //       rows[i].style.backgroundColor = i % 2 === 0 ? oddColor : evenColor;
      //     } else {
      //       rows[i].style.backgroundColor = ''; // Reset to default
      //     }
      //   }
      //   break;

      case 'Dark Theme':
        this.properties.darkTheme = event.target.checked;
        const rows1 = tableElement.nativeElement.getElementsByTagName('td');
        if (this.properties.darkTheme) {
          for (let i = 0; i < rows1.length; i++) {
            rows1[i].style.backgroundColor = 'black';
            rows1[i].style.color = 'white';
          }
        }
        else {
          for (let i = 0; i < rows1.length; i++) {
            rows1[i].style.backgroundColor = 'white';
            rows1[i].style.color = 'black';
          }
        }
        break;
      case 'Data Label Format : ':
        this.properties.datalabelFormat = event.target.value;
        const rows3 = tableElement.nativeElement.getElementsByTagName('tr');
        const cols = tableElement.nativeElement.getElementsByTagName('th');

        for (let i = 1; i < rows3.length; i++) {
          let cells = rows3[i].getElementsByTagName('td');
          for (let j = 1; j < cells.length; j++) {
            if (this.properties.datalabelFormat == 'percentage') {
              cells[j].innerHTML = (parseFloat(cells[j].innerHTML)).toFixed(2) + '%';
            }
            else {
              cells[j].innerHTML = (parseFloat(cells[j].innerHTML)).toFixed(2);
            }
          }
        }

        break;
      case 'Transpose': this.properties.transpose = event.target.checked;
        break;
      case 'Data Label Property: ':
        this.properties.datalabelStyle = event.target.value;
        break;
      case 'Number of columns':
        this.properties.colNumber = event.target.value;
        break;
      case 'Number of columns to merge':
        this.properties.mergeNumber = event.target.value;
        break;
        case 'Suppress Row':
        this.properties.suppressRow = event.target.value;
        break;
        case 'Suppress Col':
        this.properties.suprressColumn = event.target.value;
        break;
      default:
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.backgroundColor = '#ffffff';
          rows[i].style.color = 'black';
        }

    }
  }
  
  customizationService() {
    let custom: any = [
      {
        customization: 'Disable Pagination#', func: 'commonfunc', inputType: 'checkbox', value: 'pagination', className: '', id: 'Disable Pagination'

      },
      {
        customization: 'Transpose', func: 'commonfunc', inputType: 'checkbox', value: 'transpose', className: 'not', id: 'Transpose'

      },
      {
        customization: 'Suppress Row#', func: 'commonfunc', inputType: 'checkbox', value: 'suppress', className: '', id: 'Suppress Row'
      },
      {
        customization: 'Suppress Col#', func: 'commonfunc', inputType: 'checkbox', value: 'suppress', className: '', id: 'Suppress Col'
      },
      { customization: 'Alternate Row Color', func: 'commonfunc', inputType: 'checkbox', value: 'alternate Row', className: '', id: 'Alternate Row Color' },

  
      {
        customization: 'TextAlign', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'TextAlign', options: [
          { value: 'Center', label: 'Center Align' },
          { value: 'Left', label: 'Left Align' },
        ]
      },
      {
        customization: 'Border Style', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Border Style', options: [



        
          { value: 'solid', label: 'Solid' },
         
          { value: 'dotted', label: 'Dotted' },
          { value: 0, label: 'None' },


        ],
      },
      {
        customization: 'Border', func: 'commonfunc', inputType: 'color', value: 'white', className: '', id: 'Border'
      },
      {
        customization: 'Cell Color', func: 'commonfunc', inputType: 'color', value: 'white', className: '', id: 'Cell Color'

      },
      {
        customization: 'Header Color', func: 'commonfunc', inputType: 'color', value: '#f2f2f2', className: '', id: 'Header Color'


      },
      {
        customization: 'Header Text Color', func: 'commonfunc', inputType: 'color', value: 'black', className: '', id: 'Header Text Color'
      },



      {
        customization: 'Data Label Color', func: 'commonfunc', inputType: 'color', value: 'black', className: '', id: 'Data Label Color'


      },
      {
        customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'images', className: '', id: 'Data Label Format : ', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Data Label Property : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Data Label Property : ', options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Versus ' },
          { value: 'significance + changeVs', label: 'Change Versus + Significance' },

          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },


          { value: 'ls', label: 'Low Sample ' },

        ]
      },
      {
        customization: 'Data Label Size# : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },


    ]
    return custom;
  }

 
customizationServiceColumnNesting() {
  let custom: any = [
    {
      customization: 'Transpose', func: 'commonFuncNesting', inputType: 'checkbox', value: 'transpose',
      className:"Transpose",id:'Transpose'
    },
    {
      customization: 'Suppress Row', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress',
      className:"",id:'Suppress Row'
    },
    {
      customization: 'Suppress Col', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress', className:"",id:'Suppress Col'
    },
    { customization: 'Alternate Row Color', func: 'commonFuncNesting', inputType: 'checkbox', value: 'alternate Row',
    className:"",id:'Alternate Row Color' },

    // { customization: 'Dark Theme', func: 'commonFuncNesting', inputType: 'checkbox', value: 'Dark',
    // className:"",id:'Dark Theme'},
    {
      customization: 'Nesting', func: 'commonFuncNesting', inputType: 'dropdown', options: [
       
        { value: 'level3', label: 'Level 3' },
        { value: 'level2', label: 'Level 2' },
        { value: 'level1', label: 'Level 1' },
    ],className:"Nesting",id:'Nesting'},
    {
      customization: 'TextAlign', func: 'commonFuncNesting', inputType: 'dropdown', options: [
       
        { value: 'Center', label: 'Center Align' },
        { value: 'Left', label: 'Left Align' },
    ], className:"",id:'TextAlign'},
    {
      customization: 'Border Style', func: 'commonFuncNesting', inputType: 'dropdown', options: [
        { value: 'solid', label: 'Solid' },
        { value: 'dotted', label: 'Dotted' },
        { value: 0, label: 'None' },
      ],className:"",id:'Border Style'
    },
    {
      customization: 'Border', func: 'commonFuncNesting', inputType: 'color', value: '#ddd',className:"",id:'Border'
    },
  
    {
      customization: 'Cell Color', func: 'commonFuncNesting', inputType: 'color', value: 'white',className:"",id:'Cell Color'


    },
    // {
    //   customization: 'Text Color', func: 'commonFuncNesting', inputType: 'color', value: 'black'


    // },
    {
      customization: 'Header Color', func: 'commonFuncNesting', inputType: 'color', value: '#f2f2f2',className:"",id:'Header Color'


    },
    {
      customization:'Header Text Color',func:'commonFuncNesting',inputType:'color',value:'black',className:"",id:'Header Text Color'
    },
    {
      customization: 'Data Label Format : ', func: 'commonFuncNesting', inputType: 'images', options: [
        { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
        { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
      ],className:"",id:'Data Label Format : '
    },
    {
      customization: 'Data Label Property : ', func: 'commonFuncNesting', inputType: 'dropdown', options: [
        { value: 'datalabel', label: 'Default ' },
        { value: 'change', label: 'Change Versus ' },
        { value: 'significance + changeVs', label: 'Change Versus + Significance' },

        { value: 'significance', label: 'Significance ' },
        { value: 'significance2', label: 'Significance Level2' },


        { value: 'ls', label: 'Low Sample ' },

      ],className:"",id:'Data Label Property : '
    },
    { "customization": "Data Label Color : ", "func": "commonFuncNesting", "inputType": "color", "value": "#000000",className:"",id:"Data Label Color : " },

    {
      customization: 'Data Label Size : ', func: 'commonFuncNesting', inputType: 'dropdown', className: '', id: 'Data Label Size : ', options: [
        { value: '1em', label: '1 em' },
        { value: '0.9em', label: '0.9 em' },
        { value: '0.8em', label: '0.8 em' },
        { value: '0.7em', label: '0.7 em' },
      ]
    },
    //{
    //  customization: 'Cell Border', func: 'commonfunc', inputType: 'dropdown', options: [
    //    { value: 'red', label: 'Red' },
    //    { value: 'green', label: 'Green' },
    //    { value: 'blue', label: 'Blue' },
    //    { value: 'black', label: 'Black' },

    //    { value: 'none', label: 'None' },
    //    { value: 'default', label: 'Default' }
    //  ]
    //},

    //{
    //  customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'dropdown', options: [
    //    { value: 'number', label: 'Number' },
    //    { value: 'percentage', label: 'Percentage' },
    //  ]
    //},


  ]
  return custom;
}

applycustomization(event: any, item: any, properties: any) {
  this.commonchartmodules.applycustomization(event, item, properties)
}

customizationServicerowNesting() {
  let custom: any = [
    {
      customization: 'Suppress Row', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress',
      className:"",id:'Suppress Row'
    },
    {
      customization: 'Suppress Col', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress', className:"",id:'Suppress Col'
    },
    { customization: 'Alternate Row Color', func: 'commonFuncNesting', inputType: 'checkbox', value: 'alternate Row',
    className:"",id:'Alternate Row Color' },

    { customization: 'Dark Theme', func: 'commonFuncNesting', inputType: 'checkbox', value: 'Dark',
    className:"",id:'Dark Theme'},
    {
      customization: 'Nesting', func: 'commonFuncNesting', inputType: 'dropdown', options: [
        { value: 'level3', label: 'Level 3' },
        { value: 'level2', label: 'Level 2' },
    ],className:"",id:'Nesting'},
    {
      customization: 'TextAlign', func: 'commonFuncNesting', inputType: 'dropdown', options: [
       
        { value: 'Center', label: 'Center Align' },
        { value: 'Left', label: 'Left Align' },
    ], className:"",id:'TextAlign'},
    {
      customization: 'Border Style', func: 'commonFuncNesting', inputType: 'dropdown', options: [
        
      

      
        
        { value: 0, label: 'None' },
        { value: 'solid', label: 'Solid' },
        { value: 'dotted', label: 'Dotted' },


      ],className:"",id:'Border Style'
    },
    {
      customization: 'Border', func: 'commonFuncNesting', inputType: 'color', value: 'white',className:"",id:'Border'
    },
  
    {
      customization: 'Cell Color', func: 'commonFuncNesting', inputType: 'color', value: 'white',className:"",id:'Cell Color'


    },
    // {
    //   customization: 'Text Color', func: 'commonFuncNesting', inputType: 'color', value: 'black'


    // },
    {
      customization: 'Header Color', func: 'commonFuncNesting', inputType: 'color', value: '#f2f2f2',className:"",id:'Header Color'


    },
    {
      customization:'Header Text Color',func:'commonFuncNesting',inputType:'color',value:'black',className:"",id:'Header Text Color'
    },
    {
      customization: 'Data Label Format : ', func: 'commonFuncNesting', inputType: 'images', options: [
        { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
        { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
      ],className:"",id:'Data Label Format : '
    },
    {
      customization: 'Data Label Property : ', func: 'commonFuncNesting', inputType: 'dropdown', options: [
        { value: 'datalabel', label: 'Default ' },
        { value: 'change', label: 'Change Versus ' },
        { value: 'significance + changeVs', label: 'Change Versus + Significance' },

        { value: 'significance', label: 'Significance ' },
        { value: 'significance2', label: 'Significance Level2' },


        { value: 'ls', label: 'Low Sample ' },

      ],className:"",id:'Data Label Property : '
    },
    { "customization": "Data Label Color : ", "func": "commonFuncNesting", "inputType": "color", "value": "#000000",className:"",id:"Data Label Color : " },


    //{
    //  customization: 'Cell Border', func: 'commonfunc', inputType: 'dropdown', options: [
    //    { value: 'red', label: 'Red' },
    //    { value: 'green', label: 'Green' },
    //    { value: 'blue', label: 'Blue' },
    //    { value: 'black', label: 'Black' },

    //    { value: 'none', label: 'None' },
    //    { value: 'default', label: 'Default' }
    //  ]
    //},

    //{
    //  customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'dropdown', options: [
    //    { value: 'number', label: 'Number' },
    //    { value: 'percentage', label: 'Percentage' },
    //  ]
    //},


  ]
  return custom;
}

  customizationServiceRowColumnNesting() {
    let custom: any = [
      {
        customization: 'Transpose', func: 'commonFuncNesting', inputType: 'checkbox', value: 'transpose',
        className:"",id:'Transpose'
      },
      {
        customization: 'Suppress Row', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress',
        className:"",id:'Suppress Row'
      },
      {
        customization: 'Suppress Col', func: 'commonFuncNesting', inputType: 'checkbox', value: 'suppress', className:"",id:'Suppress Col'
      },
      { customization: 'Alternate Row Color', func: 'commonFuncNesting', inputType: 'checkbox', value: 'alternate Row',
      className:"",id:'Alternate Row Color' },

      // { customization: 'Dark Theme', func: 'commonFuncNesting', inputType: 'checkbox', value: 'Dark',
      // className:"",id:'Dark Theme'},
      {
        customization: 'TextAlign', func: 'commonFuncNesting', inputType: 'dropdown', options: [
         
          { value: 'Center', label: 'Center Align' },
          { value: 'Left', label: 'Left Align' },
      ], className:"",id:'TextAlign'},
      {
        customization: 'Border Style', func: 'commonFuncNesting', inputType: 'dropdown', options: [
          
          { value: 'solid', label: 'Solid' },
          { value: 'dotted', label: 'Dotted' },
          { value: 0, label: 'None' },


        ],className:"",id:'Border Style'
      },
      {
        customization: 'Border', func: 'commonFuncNesting', inputType: 'color', value: 'white',className:"",id:'Border'
      },
    
      {
        customization: 'Cell Color', func: 'commonFuncNesting', inputType: 'color', value: 'white',className:"",id:'Cell Color'


      },
      // {
      //   customization: 'Text Color', func: 'commonFuncNesting', inputType: 'color', value: 'black'


      // },
      {
        customization: 'Header Color', func: 'commonFuncNesting', inputType: 'color', value: '#f2f2f2',className:"",id:'Header Color'


      },
      {
        customization:'Header Text Color',func:'commonFuncNesting',inputType:'color',value:'black',className:"",id:'Header Text Color'
      },
      {
        customization: 'Data Label Format : ', func: 'commonFuncNesting', inputType: 'images', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ],className:"",id:'Data Label Format : '
      },
      {
        customization: 'Data Label Property : ', func: 'commonFuncNesting', inputType: 'dropdown', options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Versus ' },
          { value: 'significance + changeVs', label: 'Change Versus + Significance' },

          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },


          { value: 'ls', label: 'Low Sample ' },

        ],className:"",id:'Data Label Property : '
      },
      { "customization": "Data Label Color : ", "func": "commonFuncNesting", "inputType": "color", "value": "#000000",className:"",id:"Data Label Color : " },
      {
        customization: 'Data Label Size : ', func: 'commonFuncNesting', inputType: 'dropdown', className: '', id: 'Data Label Size : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },

      //{
      //  customization: 'Cell Border', func: 'commonfunc', inputType: 'dropdown', options: [
      //    { value: 'red', label: 'Red' },
      //    { value: 'green', label: 'Green' },
      //    { value: 'blue', label: 'Blue' },
      //    { value: 'black', label: 'Black' },

      //    { value: 'none', label: 'None' },
      //    { value: 'default', label: 'Default' }
      //  ]
      //},

      //{
      //  customization: 'Data Label Format : ', func: 'commonfunc', inputType: 'dropdown', options: [
      //    { value: 'number', label: 'Number' },
      //    { value: 'percentage', label: 'Percentage' },
      //  ]
      //},


    ]
    return custom;
  }
  headerNewCOlor = "Red";
 
  commonFunc(customization: any, event: any, property: any, tableElement: any, headerElement: any) {
    this.properties = property;
  
    const cells = tableElement.nativeElement.getElementsByClassName('data-cells');
    const rows = tableElement.nativeElement.getElementsByClassName('table-rows');
    const RowHeaderCells = tableElement.nativeElement.getElementsByClassName('data-cells3');
    const headerCells = tableElement.nativeElement.getElementsByClassName('header-cells');
    const rows2 = tableElement.nativeElement.getElementsByClassName('table-rows3');
  
  
    switch (customization) {
      case 'Border':
       
        this.properties.borderColor = event.target.value;
        
 
        break;
      case 'Border Style':
        this.properties.borderStyle = event.target.value;

        break;

       
      case 'Data Label Color':
        this.properties.dataLabelColor = event.target.value;
       
        break;
      case 'Cell Color':
        this.properties.cellColor = event.target.value;
   
        //if (this.properties.cellColor != "default") {
        //  for (let i = 0; i < cells.length; i++) {
        //    cells[i].style.backgroundColor = this.properties.cellColor;
        //  }
        //}
        //else {
        //  for (let i = 0; i < cells.length; i++) {
        //    cells[i].style.backgroundColor = this.defaultBackgroundolor;
        //  }
        //}
        break;
      case 'Header Color':
        this.properties.headerColor = event.target.value;
  
      
        for (let i = 0; i < RowHeaderCells.length; i++) {
          RowHeaderCells[i].style.backgroundColor = this.properties.headerColor;
          RowHeaderCells[i].style.color = this.darkThemeTextColor;
        }
        break;
      case 'TextAlign':
        this.properties.textAlign = event.target.value;
        let cols2 = tableElement.nativeElement.getElementsByClassName('header-cells');
        for (let i = 0; i < cells.length; i++) {
          const cell = cells[i];
          cell.style.justifyContent = event.target.value;
        }
        for (let i = 0; i < cols2.length; i++) {
          cols2[i].style.textAlign = event.target.value;
        }
        for (let i = 0; i < RowHeaderCells.length; i++) {
          RowHeaderCells[i].style.textAlign = event.target.value;
        }
  
        break;
      case 'Transpose': this.properties.transpose = event.target.classList.toggle('checked');
        break;
      case 'Alternate Row Color':
        this.properties.alternateColor = event.target.classList.toggle('checked');
  
        if (this.properties.alternateColor) {
          for (let i = 0; i < rows.length; i++) {
            if (i % 2 === 0) {
              Array.from(rows[i].children).forEach((row) => (row as HTMLElement).style.backgroundColor = '#ffffff');
              //rows[i].style.backgroundColor = '#ffffff';
            } else {
              Array.from(rows[i].children).forEach((row) => (row as HTMLElement).style.backgroundColor = '#f2f2f2');
             // rows[i].style.backgroundColor = '#f2f2f2';
            }
          }
        } else {
          for (let i = 0; i < rows.length; i++) {
            rows[i].style.backgroundColor = '#ffffff';
            rows[i].style.color = this.defaultTextColor;
          }
        }
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.classList.toggle('checked');
  
       
        
        break;
      case 'Disable Pagination': this.properties.pagination = event.target.classList.toggle('checked');
        break;
      case 'Suppress Row': this.properties.suppressRow = event.target.classList.toggle('checked');
        break;
      case 'Suppress Col': this.properties.suppressColumn = event.target.classList.toggle('checked');
        break;
      case 'Header Text Color': this.properties.headerTextColor = event.target.value;
        for (let i = 0; i < headerCells.length; i++) {
          headerCells[i].style.color = this.properties.headerTextColor;
        }
        for (let i = 0; i < RowHeaderCells.length; i++) {
          RowHeaderCells[i].style.color = this.properties.headerTextColor;
        }
        break;
      case 'Data Label Property : ':
        this.properties.datalabelStyle = event.target.value;
 
        break;
      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelFormat = value;
        break;
      case 'Number of columns':
        this.properties.colNumber = event.target.value;
        break;
      case 'Number of columns to merge':
        this.properties.mergeNumber = event.target.value;
        break;
      case 'Data Label Size# : ':
        this.properties.dataLabelSize = event.target.value;
       
        break;


      default:
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.backgroundColor = '#ffffff';
          rows[i].style.color = 'black';
        }
  
    }
 }

  commonFunc1(customization: any, event: any, property: any, tableElement: any, headerElement: any) {
    this.properties = property;

    const cells = tableElement.nativeElement.getElementsByTagName('td');
    const rows = tableElement.nativeElement.getElementsByTagName('tr');
    const cols = tableElement.nativeElement.getElementsByTagName('th');
    switch (customization) {
      case 'Border':
        this.properties.border = event.target.value;
        
          break;

      case 'Border Style':
        this.properties.border = event.target.value;
       
        break;
      case 'Text Color':
        this.properties.dataLabelColor = event.target.value;
        if (this.properties.dataLabelColor != "default") {
          tableElement.nativeElement.style.color = this.properties.dataLabelColor;

        } else {
          tableElement.nativeElement.style.color = 'black';
        }
        break;
      case 'Cell Color':
        this.properties.cellColor = event.target.value;

        if (this.properties.cellColor != "default") {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = 'white';
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = 'white';
          }
        }
        break;
      case 'Cell Border':
        this.properties.cellBorder = event.target.value;
        if (this.properties.cellBorder == 'none') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = 0;
          }
        }
        if (this.properties.cellBorder == 'default') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '1px solid #ddd';
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '5px solid ' + this.properties.cellBorder;
          }
        }

        break;
      case 'Header Color':
        this.properties.headerColor = event.target.value;
        const rows2 = tableElement.nativeElement.getElementsByTagName('th');

        for (let i = 0; i < rows2.length; i++) {
          rows2[i].style.backgroundColor = this.properties.headerColor;
          rows2[i].style.color = 'white';

        }
        break;
      case 'Cell Border':
        this.properties.cellBorder = event.target.value;
        if (this.properties.cellBorder == 'none') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = 0;
          }
        }
        if (this.properties.cellBorder == 'default') {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '1px solid #ddd';
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.border = '5px solid ' + this.properties.cellBorder;
          }
        }

        break;
      case 'Alternate Row Color':
        this.properties.alternateColor = event.target.checked;
        const rows = tableElement.nativeElement.getElementsByTagName('tr');
        if (this.properties.alternateColor) {
          for (let i = 2; i < rows.length; i++) {
            if (i % 2 === 0) {

              tableElement.nativeElement.style.backgroundColor = '#f2f2f2';
            } else {

              tableElement.nativeElement.style.backgroundColor = '#ffffff';
            }
          }
        } else {
          for (let i = 2; i < rows.length; i++) {
            rows[i].style.backgroundColor = '#ffffff';
            rows[i].style.color = 'black';
          }
        }
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.checked;
        const rows1 = tableElement.nativeElement.getElementsByTagName('td');
        if (this.properties.darkTheme) {
          for (let i = 0; i < rows1.length; i++) {
            rows1[i].style.backgroundColor = 'black';
            rows1[i].style.color = 'white';
          }
        }
        else {
          for (let i = 0; i < rows.length; i++) {
            rows1[i].style.backgroundColor = 'white';
            rows1[i].style.color = 'black';
          }
        }
        break;
      case 'Data Label Format : ':
        this.properties.datalabelFormat = event.target.value;
        const rows3 = tableElement.nativeElement.getElementsByTagName('tr');
        const cols = tableElement.nativeElement.getElementsByTagName('th');

        for (let i = 1; i < rows3.length; i++) {
          let cells = rows3[i].getElementsByTagName('td');
          for (let j = 1; j < cells.length; j++) {
            if (this.properties.datalabelFormat == 'percentage') {
              cells[j].innerHTML = (parseFloat(cells[j].innerHTML)).toFixed(2) + '%';
            }
            else {
              cells[j].innerHTML = (parseFloat(cells[j].innerHTML)).toFixed(2);
            }
          }
        }

        break;

      case 'Data Label Property: ':
        this.properties.datalabelStyle = event.target.value;
        break;
      case 'Number of columns':
        this.properties.colNumber = event.target.value;
        break;

      default:
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.backgroundColor = '#ffffff';
          rows[i].style.color = 'black';
        }


    }
  }
  customizationService2() {
    let custom: any = [
      { customization: 'Number of columns', func: 'commonfunc', inputType: 'number', value: 'colNumber' },

      { customization: 'Number of columns to merge', func: 'commonfunc', inputType: 'number', value: 2 },
      {
        customization: 'Level', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 1, label: 'Level 1' },
          { value: 2, label: 'Level 2' },
        ]
      },

      { customization: 'Alternate Row Color', func: 'commonfunc', inputType: 'checkbox', value: 'alternate Row' },
     
      {
        customization: 'Border', func: 'commonfunc', inputType: 'color', value: 'white'
      },


      {
        customization: 'Border Style', func: 'commonfunc', inputType: 'color', options: [
          { value: 'dash', label: 'Dashed' },
          { value: 'dotted', label: 'Dotted' },

          { value: 'solid', label: 'Solid' },
          { value: 0, label: 'None' }


        ],
      },
      {
        customization: 'Text Color', func: 'commonfunc', inputType: 'dropdown', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },

        ]
      },
      {
        customization: 'Cell Color', func: 'commonfunc', inputType: 'color', value: 'white'


      },
      {
        customization: 'Header Color', func: 'commonfunc', inputType: 'color', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },

        ]
      },
      {
        customization: 'Cell Border', func: 'commonfunc', inputType: 'dropdwon', options: [
          { value: 'red', label: 'Red' },
          { value: 'green', label: 'Green' },
          { value: 'blue', label: 'Blue' },
          { value: 'black', label: 'Black' },

          { value: 'none', label: 'None' },
          { value: 'default', label: 'Default' }
        ]
      }

    ]
    return custom;
  }
  commonFuncNesting(customization: any, event: any, property: any, tableElement: any) {
    this.properties = property;

    const cells = tableElement.nativeElement.getElementsByClassName('row-cell-block');
    const rows = tableElement.nativeElement.getElementsByClassName('row-data-container');
    const headerCells = tableElement.nativeElement.getElementsByClassName('preview-row-header');
    const colHeaderCells = tableElement.nativeElement.getElementsByClassName('row-header-text');
    switch (customization) {
     
      case 'Data Label Size : ':
        this.properties.dataLabelSize=event.target.value;
        break;
      case 'Border':{
         this.properties.border = event.target.value;
        
        if (this.properties.border != 0){
        const borderWidth = this.properties.borderStyle != 0 ?'1px':'0px'; // Default border width
        const borderColor =this.properties.border != 0 ? this.properties.border : "#C9C9C9";
        const borderStyle = this.properties.borderStyle != 0 ? this.properties.borderStyle : "none";
        // Concatenate the border style, width, and color
        let borderValue = `${borderWidth} ${borderStyle} ${borderColor}`;
        let emptyRows = tableElement.nativeElement.getElementsByClassName('empty-row-block');
        let emptyCols = tableElement.nativeElement.getElementsByClassName('empty-col-nesting');
        let rowHeaders = tableElement.nativeElement.getElementsByClassName('preview-row-header-text');
        let rowNestingHeaders = tableElement.nativeElement.getElementsByClassName('row-nest-header');
        let colHeaders = tableElement.nativeElement.getElementsByClassName('row-header-text');
        let colNestingHeaders = tableElement.nativeElement.getElementsByClassName('col-nest-header');
        let dataCells = tableElement.nativeElement.getElementsByClassName('row-cell-block');
        //let lastColNesting = tableElement.nativeElement.getElementsByClassName('col-nesting-block');

          // for (let i = 0; i < emptyRows.length; i++) {
          //   emptyRows[i].style.borderLeft = borderValue;
          //   emptyRows[i].style.borderRight = borderValue;
          //   emptyRows[i].style.borderTop = borderValue;
          // }
          // for (let i = 0; i < emptyCols.length; i++) {
          //   emptyCols[i].style.borderLeft = borderValue;
          //   emptyCols[i].style.borderRight = borderValue;
          //   emptyCols[i].style.borderTop = borderValue;
          // }
          // var lastEmptyCol = emptyCols[emptyCols.length - 1];
          // lastEmptyCol.style.borderBottom = borderValue;
          // Get all elements with class 'row-block'
          var elements = tableElement.nativeElement.getElementsByClassName('row-block');
          
          for(let i=0;i<elements.length;i++){
            var colNestingBlocks = elements[i].getElementsByClassName('col-nesting-block');
            var lastColNestingBlock = colNestingBlocks[colNestingBlocks.length - 1];
          lastColNestingBlock.style.borderBottom = borderValue;
           }

          for (let i = 0; i < rowHeaders.length; i++) {
            rowHeaders[i].style.borderLeft = borderValue;
            rowHeaders[i].style.borderRight = borderValue;
            rowHeaders[i].style.borderBottom = borderValue;
          }
          for (let i = 0; i < rowNestingHeaders.length; i++) {
            rowNestingHeaders[i].style.borderRight = borderValue;
            rowNestingHeaders[i].style.borderBottom = borderValue;
          }
          for (let i = 0; i < colHeaders.length; i++) {
            colHeaders[i].style.borderRight = borderValue;
            colHeaders[i].style.borderTop = borderValue;
          }
          for (let i = 0; i < colNestingHeaders.length; i++) {
            colNestingHeaders[i].style.borderRight = borderValue;
            colNestingHeaders[i].style.borderTop = borderValue;
          }
          for (let i = 0; i < dataCells.length; i++) {
            dataCells[i].style.borderRight = borderValue;
            dataCells[i].style.borderBottom = borderValue;
          }
        }
       
      }
          break;

      case 'Border Style':
        this.properties.borderStyle = event.target.value;
        let borderWidth =  this.properties.borderStyle==0?'0px':'1px'; // Default border width
        let borderColor =this.properties.border != 0 ? this.properties.border : "#C9C9C9";
        let borderStyle = this.properties.borderStyle != 0 ? this.properties.borderStyle : "none";

        // Concatenate the border style, width, and color
        let borderValue = `${borderWidth} ${borderStyle} ${borderColor}`;
        let emptyRows = tableElement.nativeElement.getElementsByClassName('empty-row-block');
        let emptyCols = tableElement.nativeElement.getElementsByClassName('empty-col-nesting');
        let rowHeaders = tableElement.nativeElement.getElementsByClassName('preview-row-header-text');
        let rowNestingHeaders = tableElement.nativeElement.getElementsByClassName('row-nest-header');
        let colHeaders = tableElement.nativeElement.getElementsByClassName('row-header-text');
        let colNestingHeaders = tableElement.nativeElement.getElementsByClassName('col-nest-header');
        let dataCells = tableElement.nativeElement.getElementsByClassName('row-cell-block');
        //let lastColNesting = tableElement.nativeElement.getElementsByClassName('col-nesting-block');

        if (this.properties.borderStyle != 0) {
          // for (let i = 0; i < emptyRows.length; i++) {
          //   emptyRows[i].style.borderLeft = borderValue;
          //   emptyRows[i].style.borderRight = borderValue;
          //   emptyRows[i].style.borderTop = borderValue;
          // }
          // for (let i = 0; i < emptyCols.length; i++) {
          //   emptyCols[i].style.borderLeft = borderValue;
          //   emptyCols[i].style.borderRight = borderValue;
          //   emptyCols[i].style.borderTop = borderValue;
          // }
          // var lastEmptyCol = emptyCols[emptyCols.length - 1];
          // lastEmptyCol.style.borderBottom = borderValue;
         // Get all elements with class 'row-block'
         var elements = tableElement.nativeElement.getElementsByClassName('row-block');
        
         for(let i=0;i<elements.length;i++){
          var colNestingBlocks = elements[i].getElementsByClassName('col-nesting-block');
          var lastColNestingBlock = colNestingBlocks[colNestingBlocks.length - 1];
          lastColNestingBlock.style.borderBottom = borderValue;
         }

          for (let i = 0; i < rowHeaders.length; i++) {
            rowHeaders[i].style.borderLeft = borderValue;
            rowHeaders[i].style.borderRight = borderValue;
            rowHeaders[i].style.borderBottom = borderValue;
          }
          for (let i = 0; i < rowNestingHeaders.length; i++) {
            rowNestingHeaders[i].style.borderRight = borderValue;
            rowNestingHeaders[i].style.borderBottom = borderValue;
          }
          for (let i = 0; i < colHeaders.length; i++) {
            colHeaders[i].style.borderRight = borderValue;
            colHeaders[i].style.borderTop = borderValue;
          }
          for (let i = 0; i < colNestingHeaders.length; i++) {
            colNestingHeaders[i].style.borderRight = borderValue;
            colNestingHeaders[i].style.borderTop = borderValue;
          }
          for (let i = 0; i < dataCells.length; i++) {
            dataCells[i].style.borderRight = borderValue;
            dataCells[i].style.borderBottom = borderValue;
          }
          //tableElement.nativeElement.style.border = this.properties.border;
        } 
        // else {
        //   // for (let i = 0; i < emptyRows.length; i++) {
        //   //   emptyRows[i].style.borderLeft = borderValue;
        //   //   emptyRows[i].style.borderRight = borderValue;
        //   //   emptyRows[i].style.borderTop = borderValue;
        //   // }
        //   // for (let i = 0; i < emptyCols.length; i++) {
        //   //   emptyCols[i].style.borderLeft = borderValue;
        //   //   emptyCols[i].style.borderRight = borderValue;
        //   //   emptyCols[i].style.borderTop = borderValue;
        //   // }
        //   // var lastEmptyCol = emptyCols[emptyCols.length - 1];
        //   // lastEmptyCol.style.borderBottom = borderValue;
        //  // Get all elements with class 'row-block'
        //  var elements = tableElement.nativeElement.getElementsByClassName('row-block');
         
        //  for(let i=0;i<elements.length;i++){
        //   var colNestingBlocks = elements[i].getElementsByClassName('col-nesting-block');
        //   var lastColNestingBlock = colNestingBlocks[colNestingBlocks.length - 1];
        //   lastColNestingBlock.style.borderBottom = borderValue;
        //  }
        //   for (let i = 0; i < rowHeaders.length; i++) {
        //     rowHeaders[i].style.borderLeft = borderValue;
        //     rowHeaders[i].style.borderRight = borderValue;
        //     rowHeaders[i].style.borderBottom = borderValue;
        //   }
        //   for (let i = 0; i < rowNestingHeaders.length; i++) {
        //     rowNestingHeaders[i].style.borderRight = borderValue;
        //     rowNestingHeaders[i].style.borderBottom = borderValue;
        //   }
        //   for (let i = 0; i < colHeaders.length; i++) {
        //     colHeaders[i].style.borderRight = borderValue;
        //     colHeaders[i].style.borderTop = borderValue;
        //   }
        //   for (let i = 0; i < colNestingHeaders.length; i++) {
        //     colNestingHeaders[i].style.borderRight = borderValue;
        //     colNestingHeaders[i].style.borderTop = borderValue;
        //   }
        //   for (let i = 0; i < dataCells.length; i++) {
        //     dataCells[i].style.borderRight = borderValue;
        //     dataCells[i].style.borderBottom = borderValue;
        //   }
        // }
        break;
      case 'Text Color':
        this.properties.dataLabelColor = event.target.value;
        if (this.properties.dataLabelColor != "default") {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.color = this.properties.dataLabelColor;
          }

        } else {
          tableElement.nativeElement.style.color = this.defaultTextColor;
        }
        break;
      case 'Cell Color':
        this.properties.cellColor = event.target.value; 

        if (this.properties.cellColor != "default") {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = this.properties.cellColor;
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = this.defaultBackgroundolor;
          }
        }
        break;     
      case 'Header Color':
        this.properties.headerColor = event.target.value;

      
        for (let i = 0; i < headerCells.length; i++) {
          headerCells[i].style.backgroundColor = this.properties.headerColor;
          //headerCells[i].style.color = this.darkThemeTextColor;
         
        }
        for (let i = 0; i < colHeaderCells.length; i++) {
          colHeaderCells[i].style.backgroundColor = this.properties.headerColor;
          //headerCells[i].style.color = this.darkThemeTextColor;
         
        }
        break;
      case 'Header Text Color': 
        this.properties.headerTextColor = event.target.value;
        for (let i = 0; i < headerCells.length; i++) {
          headerCells[i].style.color = this.properties.headerTextColor;
        }
        for (let i = 0; i < colHeaderCells.length; i++) {
          colHeaderCells[i].style.color = this.properties.headerTextColor;
        }
        break; 
      case 'Alternate Row Color':
        this.properties.alternateColor =  event.target.classList.toggle('checked');
        if (this.properties.alternateColor) {
          for (let i = 0; i < rows.length; i++) {
            if (i % 2 === 0) {
              
              Array.from(rows[i].children).forEach((row) =>{ (row as HTMLElement).style.backgroundColor = '#ffffff'; });
              // rows[i].style.backgroundColor = '#ffffff';
            } else {
              Array.from(rows[i].children).forEach((row) => (row as HTMLElement).style.backgroundColor = '#f2f2f2');
            //  rows[i].style.backgroundColor = '#f2f2f2';
            }
          }
        } else {
          for (let i = 0; i < rows.length; i++) {
            Array.from(rows[i].children).forEach((row) => (row as HTMLElement).style.backgroundColor = '#ffffff');
            Array.from(rows[i].children).forEach((row) => (row as HTMLElement).style.color = this.defaultTextColor);
          }
        }
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.classList.toggle('checked');

        if (this.properties.darkTheme) {
        
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = this.darkThemeBackgroundColor;
            cells[i].style.color = this.darkThemeTextColor;
          }
        }
        else {
          for (let i = 0; i < cells.length; i++) {
            cells[i].style.backgroundColor = this.defaultBackgroundolor;
            cells[i].style.color = this.defaultTextColor;
          }
        }
        break;
      case 'TextAlign':
        this.properties.textAlign = event.target.value;
        let row = tableElement.nativeElement.getElementsByClassName('row-col-header-title');
        let rowNesting = tableElement.nativeElement.getElementsByClassName('row-nest-header-txt');
        let column = tableElement.nativeElement.getElementsByClassName('row-header-title');
        let colNesting = tableElement.nativeElement.getElementsByClassName('col-nest-header-txt');
        let cellData = tableElement.nativeElement.getElementsByClassName('cell-data');
        
        for (let i = 0; i < column.length; i++) {
          column[i].style.textAlign = event.target.value;
        
        }
        for (let i = 0; i < colNesting.length; i++) {
          colNesting[i].style.textAlign = event.target.value;
        }
        for (let i = 0; i < row.length; i++) {
          row[i].style.textAlign = event.target.value;
        
        }
        for (let i = 0; i < rowNesting.length; i++) {
          rowNesting[i].style.textAlign = event.target.value;
        }
        for (let i = 0; i < cellData.length; i++) {
          cellData[i].style.textAlign = event.target.value;
        }

        break;
      case 'Transpose': this.properties.transpose = event.target.classList.toggle('checked');
        break;  
      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelFormat = value;
        break;
      case 'Nesting':
        this.properties.nestingLevel = event.target.value;
        break;
      case 'Data Label Property : ': this.properties.datalabelStyle = event.target.value;
        break;  
      case 'Data Label Color : ': this.properties.dataLabelColor = event.target.value;
        break; 
        case 'Suppress Row': this.properties.suppressRow = event.target.classList.toggle('checked');
        break;  
        case 'Suppress Col': this.properties.suprressColumn = event.target.classList.toggle('checked');
        break;  
      default:
        for (let i = 0; i < rows.length; i++) {
          rows[i].style.backgroundColor = '#ffffff';
          rows[i].style.color = 'black';
        }


    }
  }

  //----------------------------------------------------

  customColors = ["#9BC5E5", "#D5BCE4", "#F9C099", "#FF97A8", "#A6E2D7", "#BDE6BD", "#BFE1FD", "#F4E4B3", "#CD978B", "#EAC4D5"];

  customColors1 = this.color.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });

  darkThemebg = '#333';
  lightThemebg = 'white';
  //darkThemeTextColor = 'white';
  lightThemeTextColor = 'black';
  textfont = 'KantarBrown-Regular';
  //upwardTriangle = '&#9650';
  //downwardTriangle = '\u25BC';
  //sampleSizeConstant = 9000;

  updatedCategories = [
    { name: 'Brand 1', image: 'https://png.pngtree.com/png-vector/20201118/ourmid/pngtree-hand-drawn-football-sport-clipart-png-image_2426673.jpg' },
    { name: 'Brand 2', image: 'https://i.pinimg.com/originals/0d/66/ba/0d66ba7c57ff53f04022be1454310ec1.jpg' },
    { name: 'Brand 3', image: 'https://img.freepik.com/free-vector/doodle-soccer-ball_1034-741.jpg' },
    { name: 'Brand 4', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRSIXt1IiIErrRelj-eHdYp6uR7t0Prbyyew&usqp=CAU' },
    { name: 'Brand 5', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj-tNVfUPwIntNMeHAUJGK1RXi7fKc5VSlxw&usqp=CAU' },
    { name: 'Brand 6', image: 'https://i.pinimg.com/originals/0d/66/ba/0d66ba7c57ff53f04022be1454310ec1.jpg' }
  ];

  xAxisLabelOrientation(xAxisLabelOrientation: any, properties: any) {
    let rotation = 0; // Default rotation value for horizontal orientation

    if (xAxisLabelOrientation === 'vertical') {
      rotation = -90; // Rotate labels to vertical orientation
    } else if (xAxisLabelOrientation === 'angled') {
      rotation = -45; // Rotate labels to an angled orientation
    }

    return rotation;
  }

  customizeLegend(showlegend: any, legendPos: any, properties: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'center';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';

    if (showlegend) {
      switch (legendPos) {
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          showlegend = false
          break;
      }
    }

    return {
      enabled: showlegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemHiddenStyle: {
        color: "gray"
      },
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
        fontWeight: "normal",
        fontFamily: this.textfont,
        fontSize: '0.9em'
      },
      symbolRadius: 0 
    };
  }

  customizeLegend1(showLegend: any, legendPosition: any, theme: any, stacking: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'left';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';
    let legendWidthValue: any = null;
    if (showLegend) {
      switch (legendPosition) {
        case "top":
          alignLegend = 'top';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          //legendWidthValue = '20%';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          // No need to change anything for the default case
          break;
      }
    }

    return {
      enabled: showLegend,
      reversed: (stacking == 1 || stacking == 2) ? true : false,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemStyle: {
        color: theme ? "white" : "Black",
        fontWeight: "normal",
        // fontSize: "0.8em",
        fontFamily: "KantarBrown-Regular",
        overflow: 'ellipsis',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      width: legendWidthValue,
      itemDistance: 12,
      symbolRadius: 4,
      labelFormatter: function() {
        const maxLength = 30;
        const name = this.name || '';
        return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
      }
    } as any;
  }

  customizeLegendRadar(showlegend: any, legendPos: any, properties: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'center';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';

    if (showlegend) {
      switch (legendPos) {
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          showlegend = false
          break;
      }
    }

    return {
      enabled: showlegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemHiddenStyle: {
        color: "gray"
      },
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
        fontWeight: "normal",
        fontFamily: this.textfont,
        fontSize: '0.6em'
      }
    };
  }

  customizationStack() {
    let custom: any = [
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Dark Theme' },
      { customization: 'Gridlines', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Gridlines' },
      { customization: 'Shadow', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Shadow' },
      {
        customization: 'Marker Style# : ', func: 'commonfunc', inputType: 'dropdown',className:"", id:'Marker Style# : ', options: [
          { value: 'Circle', label: 'Circle' },
          { value: 'Diamond', label: 'Diamond' },
          { value: 'Square', label: 'Square' },
          { value: 'Triangle', label: 'Triangle' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'commonfunc', inputType: 'dropdown',className:"", id:'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'commonfunc', inputType: 'images',className:"", id:'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Legend : ', func: 'commonfunc', inputType: 'images',className:"Legend", id:'Legend : ', options: [
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ]
      },
      {
        customization: 'Position : ', func: 'commonfunc', inputType: 'images',className:"LegendGrouping", id:'Legend Position : ', options: [

          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: true, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'commonfunc', inputType: 'toggle',className:"DataLabel", id:'Data Label : ', options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ]
      },
      {
        customization: 'Overlap# : ', func: 'commonfunc', inputType: 'images',className:'DataLabelGrouping', 
        id: 'Data Label Overlap# : ',
        options: [
          { value: 'disable', label: 'Disable', selected: true, imgClassName: 'labelOverlapDisable', selectedImgClassName: 'labelOverlapDisableSelected' },
          { value: 'enable', label: 'Enable', selected: false, imgClassName: 'labelOverlapEnable', selectedImgClassName: 'labelOverlapEnableSelected' },
        ]
      },
      { "customization": "Color : ", "func": "commonfunc", "inputType": "color", "value": "#000000",className:"DataLabelGrouping", id:'Data Label Color : ' },
      {
        customization: 'Format : ', func: 'commonfunc', inputType: 'images',className:"DataLabelGrouping", id:'Data Label Format : ', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Property : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Property : ', options: [
          { value: 'datalabel', label: 'Default' },
          { value: 'change', label: 'Change Versus' },
          { value: 'sigchan', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'lowSample', label: 'Low Sample' },
        ]
      },
      {
        customization: 'Size# : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
      {
        customization: 'Position# : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Position# : ', options: [
          { value: 'center', label: 'Center' },
          { value: 'right', label: 'Left' },
          { value: 'left', label: 'Right' },
        ]
      }
    ];
    return custom;
  }

  customizationStack1() {
    let custom: any = [
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Dark Theme' },
      { customization: 'Gridlines', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Gridlines' },
      { customization: 'Shadow', func: 'commonfunc', inputType: 'checkbox',className:"", id:'Shadow' },
      {
        customization: 'Marker Style : ', func: 'commonfunc', inputType: 'dropdown',className:"", id:'Marker Style : ', options: [
          { value: 'Circle', label: 'Circle' },
          { value: 'Diamond', label: 'Diamond' },
          { value: 'Square', label: 'Square' },
          { value: 'Triangle', label: 'Triangle' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'commonfunc', inputType: 'dropdown',className:"", id:'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'commonfunc', inputType: 'images',className:"", id:'Chart Title Position : ', options: [
          { value: 'left', label: 'Left', selected: false, imgClassName: 'titleLeft', selectedImgClassName: 'titleLeftSelected' },
          { value: 'center', label: 'Center', selected: true, imgClassName: 'titleCenter', selectedImgClassName: 'titleCenterSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'titleRight', selectedImgClassName: 'titleRightSelected' },
        ]
      },
      {
        customization: 'Legend : ', func: 'commonfunc', inputType: 'images',className:"Legend", id:'Legend : ', options: [
          { value: 'disable', label: 'Disable', selected: false, imgClassName: 'legendDisable', selectedImgClassName: 'legendDisableSelected' },
          { value: 'enable', label: 'Enable', selected: true, imgClassName: 'legendEnable', selectedImgClassName: 'legendEnableSelected' },

        ]
      },
      {
        customization: 'Position : ', func: 'commonfunc', inputType: 'images',className:"LegendGrouping", id:'Legend Position : ', options: [

          { value: 'left', label: 'Left', selected: false, imgClassName: 'legendLeft', selectedImgClassName: 'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom', selected: true, imgClassName: 'legendBottom', selectedImgClassName: 'legendBottomSelected' },
          { value: 'right', label: 'Right', selected: false, imgClassName: 'legendRight', selectedImgClassName: 'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'commonfunc', inputType: 'toggle',className:"DataLabel", id:'Data Label : ', options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ]
      },
      {
        customization: 'Overlap# : ', func: 'commonfunc', inputType: 'images',className:"DataLabelGrouping", id:'Data Label Overlap# : ', options: [
            { value: 'disable', label: 'Disable', selected: true, imgClassName: 'labelOverlapDisable', selectedImgClassName: 'labelOverlapDisableSelected' },
            { value: 'enable', label: 'Enable', selected: false, imgClassName: 'labelOverlapEnable', selectedImgClassName: 'labelOverlapEnableSelected' },
        ]
      },
      { "customization": "Color : ", "func": "commonfunc", "inputType": "color", "value": "#000000",className:"DataLabelGrouping", id:'Data Label Color : ' },
      {
        customization: 'Format : ', func: 'commonfunc', inputType: 'images',className:"DataLabelGrouping", id:'Data Label Format : ', options: [
          { value: 'number', label: 'Number', selected: true, imgClassName: 'formatNumber', selectedImgClassName: 'formatNumberSelected' },
          { value: 'percentage', label: 'Percentage', selected: false, imgClassName: 'formatPercentage', selectedImgClassName: 'formatPercentageSelected' },
        ]
      },
      {
        customization: 'Property : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Property : ', options: [
          { value: 'datalabel', label: 'Default' },
          { value: 'change', label: 'Change Versus' },
          { value: 'sigchan', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'lowSample', label: 'Low Sample' },
        ]
      },
      {
        customization: 'Size# : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
      {
        customization: 'Position# : ', func: 'commonfunc', inputType: 'dropdown',className:"DataLabelGrouping", id:'Data Label Position# : ', options: [
          { value: 'center', label: 'Center' },
          { value: 'right', label: 'Left' },
          { value: 'left', label: 'Right' },
        ]
      }
    ];
    return custom
  }

  getDarkerShade(color: any) {
    const darkenFactor = 0.9; // Adjust this factor for a darker shade
    const rgb = color.substring(1); // Remove the '#' from the color
    const r = parseInt(rgb.substring(0, 2), 16);
    const g = parseInt(rgb.substring(2, 4), 16);
    const b = parseInt(rgb.substring(4, 6), 16);
    const darkerR = Math.round(r * darkenFactor);
    const darkerG = Math.round(g * darkenFactor);
    const darkerB = Math.round(b * darkenFactor);
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  }


  //properties: any;
  commonFunc2(customization: any, event: any, property: any) {
    this.properties = property;
    switch (customization) {
      case 'Gridlines':
        this.properties.gridlines = event.target.classList.toggle('checked') ? true : false;
        break;
      case 'Shadow':
        this.properties.shadow = event.target.classList.toggle('checked');
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.classList.toggle('checked');
        break;
      case 'Marker Style : ':
        this.properties.markerStyle = event.target.value;
        switch (event.target.value) {
          case 'Circle':
            this.properties.markerStyle = 'circle';
            break;
          case 'Diamond':
            this.properties.markerStyle = 'diamond';
            break;
          case 'Triangle':
            this.properties.markerStyle = 'triangle';
            break;
          case 'Square':
            this.properties.markerStyle = 'square';
            break;
          default:
            this.properties.markerStyle = event.target.value;
        }
        break;
      case 'Marker Style# : ':
        this.properties.markerStyle = event.target.value;
        switch (event.target.value) {
          case 'Circle':
            this.properties.markerStyle = 'circle';
            break;
          case 'Diamond':
            this.properties.markerStyle = 'diamond';
            break;
          case 'Triangle':
            this.properties.markerStyle = 'triangle';
            break;
          case 'Square':
            this.properties.markerStyle = 'square';
            break;
          default:
            this.properties.markerStyle = event.target.value;
        }
        break;
      case 'Chart Title Position : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.chartTitlePosition = value;
        break;
      case 'Axis Label Orientation : ':
        this.properties.axisLabelOrientation = event.target.value;
        break;
      case 'Gradient Bar Color':
        this.properties.gradientBarColor = event.target.checked;
        break;
      case 'Data Label : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showDataLabel = (value == 'enable' ? true : false);
        break;
      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelFormat = value;
        break;
      case 'Data Label Property : ':
        this.properties.datalabelStyle = event.target.value;
        break;
      case 'Data Label Position# : ':
        this.properties.dataLabelPosition = event.target.value;
        break;
      case 'Legend Position : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.legendPosition = value;
        break;
      case 'Legend : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showLegend = (value == 'enable' ? true : false);
        break;
      case 'Data Label Color : ':
        this.properties.dataLabelColor = event.target.value;
        break;
      case 'Data Label Position* : ':
        this.properties.dataLabelPosition = event.target.value;
        break;
      case 'Data Label Overlap# : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.allowOverlap = (value == 'enable' ? true : false);
        break;
      case 'ToolTip Style# : ':
        this.properties.toolTipStyle = event.target.value;
        break;
      case 'Data Label Size# : ':
        this.properties.dataLabelSize = event.target.value;
        break;
    }
  }

   axisLabelOrientation(axisLabelOrientation: any) {
    let rotationValue = 0;
    switch (axisLabelOrientation) {
      case 'vertical':
        rotationValue = -90; // or 90 depending on your preference
        break;
      case 'angled':
        rotationValue = -45; // or -90 depending on your preference
        break;
      default:
        rotationValue = 0;
        break;
    }
    return rotationValue
  }
}
